import { createAction } from '@reduxjs/toolkit';
import * as types from './type';
import axiosAdapter from '../../../utils/Adapters';
import { CMSAPI, CMSAPI_INDEX } from '../../../utils/CmsAPI';
import config from '../../../config';
import { currentDate } from '../../../utils/Helper';

const reset = createAction(types.ACTION_RESET);
const requestFetch = createAction(types.ACTION_REQUEST);
const receiveSuccess = createAction(types.ACTION_SUCCESS);
const receiveError = createAction(types.ACTION_ERROR);

const massageData = (response) => {
  // return response.data.result.assets.map((v) => {
  //   const { content, metadata, ...rest } = v;
  //   return {
  //     ...rest,
  //     topMetadata: metadata,
  //     ...v.content.content,
  //   };
  // });

  const data = response.data.result.assets;
  if (Array.isArray(data) && data.length > 0) {
    return data.map((v) => {
      const { content, metadata, ...rest } = v;
      return {
        ...rest,
        topMetadata: metadata,
        ...v.content.content,
      };
    });
  } else {
    throw new Error('no data');
  }

  // const responseData = response.data;
  // const data = responseData.result.assets[0];
  // if (!data) {
  //   throw new Error('no data');
  // }
  // return data;
};

const messageError = (error) => {
  const message =
    ((((error || {}).response || {}).data || {}).error || {}).message || error.message;
  return message;
};

const fetchData = (pageName, pageType, conditions, isStaticPage) => {
  let url;
  if (isStaticPage) {
    url = CMSAPI(
      config.lscsPath,
      pageName,
      pageType,
      config.cmsProjectName,
      false,
      // currentDate().getTime(),
    );
  } else {
    const queryParameters = {
      prefixPath: config.lscsPath,
      q: `(TeamSite/Templating/DCR/Type:${pageType})${conditions ? ` ${conditions}` : ''}`,
      start: null,
      max: null,
      projectName: config.cmsProjectName,
      enableDate: false,
    };
    url = CMSAPI_INDEX(queryParameters);
  }

  return axiosAdapter({
    url,
  });
};

const resetPages = () => {
  return (dispatch) => {
    dispatch(reset());
  };
};

const getPages = (
  pageName,
  pageType = config.pageType.staticPage,
  conditions = 'AND (displayStatus:true)',
  isStaticPage = false,
) => {
  return (dispatch) => {
    window.onUrlChangeCallBack = null;
    dispatch(requestFetch({ pageName, pageType }));
    return fetchData(pageName, pageType, conditions, isStaticPage)
      .then((response) => massageData(response))
      .then((data) => {
        dispatch(receiveSuccess(data));
      })
      .catch((error) => {
        const message = messageError(error);
        dispatch(receiveError(message));
      });
  };
};

export { getPages, resetPages };
